import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";
import { articles } from "@/mocks/articles";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="border-t border-background-200 bg-secondary-50">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-layout-grid-line w-5 h-5 flex items-center justify-center" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                AllChinaBuy <span className="text-primary-600">Spreadsheet</span>
              </span>
            </Link>
            <p className="mt-4 max-w-sm text-sm text-foreground-600">
              {t("footer.tagline")}
            </p>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-900">
              {t("nav.categories")}
            </h4>
            <ul className="mt-3 grid grid-cols-1 gap-1.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.key}>
                  <a
                    href={cat.href}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {t(`categories.${cat.key}`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-900">
              {t("nav.guides")}
            </h4>
            <ul className="mt-3 flex flex-col gap-1.5">
              {articles.slice(0, 5).map((article) => (
                <li key={article.slug}>
                  <Link
                    to={`/article/${article.slug}`}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {t(`articles.${article.slug}.title`)}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                >
                  {t("backHome")}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="mt-10 rounded-lg border border-background-200 bg-background-50 p-5">
          <h4 className="text-sm font-semibold text-foreground-900">
            {t("footer.disclaimerTitle")}
          </h4>
          <p className="mt-2 text-xs leading-relaxed text-foreground-600">
            {t("footer.disclaimer")}
          </p>
        </div>

        <div className="mt-6 flex flex-col items-start justify-between gap-2 border-t border-background-200 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-foreground-500">{t("footer.rights")}</p>
          <p className="text-xs text-foreground-500">
            AllChinaBuy Spreadsheet 2026
          </p>
        </div>
      </div>
    </footer>
  );
}